import Vue from "vue";
// Custom
import MastheadSearch from "./directives/masthead-search";

// Register
Vue.directive("masthead-search", MastheadSearch);
